import type { JSX } from 'react'

export const QualityBadgeFhdIcon = (): JSX.Element => (
  <use href='#qualityBadgeFhdIcon' height='100%' width='100%' />
)
